import React from "react";
import "./../../index.css";
import * as c from "./../../const";

export default function Banner(props) {
  const src = `${c.URL}/${props.img}`;
  
  return (
    <></>
    // <img
    //   src={src}
    //   alt="banner"
    //   style={{
    //     height: "300px",
    //     width: "100%",
    //     objectFit: "cover",
    //     objectPosition: "100% 60%",
    //   }}
    // />
  );
}
